import React, { useId } from "react";
import { FieldBadge } from "./InputField";

export default function SelectField({
  label,
  value,
  onChange, // onChange(value) — 값을 그대로 전달
  options = [],
  placeholder,
  darkMode = false,
  icon,
  required,
  id,
  style = {},
  ...props
}) {
  const generatedId = useId();
  const selectId = id || `select-${generatedId.replace(/:/g, "")}`;
  const selectStyle = {
    width: "100%",
    padding: "15px 40px 15px 16px",
    background: darkMode ? "rgba(255,255,255,0.08)" : "rgba(255,255,255,0.95)",
    border: `1.5px solid ${darkMode ? "rgba(129,140,248,0.3)" : "rgba(99,102,241,0.25)"}`,
    borderRadius: 14,
    color: darkMode ? "#FFFFFF" : "#0F172A",
    fontWeight: 600,
    fontFamily: "inherit",
    outline: "none",
    boxSizing: "border-box",
    transition: "all 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
    appearance: "none",
    WebkitAppearance: "none",
    cursor: "pointer",
    letterSpacing: "0.01em",
    minHeight: 50,
    ...style,
  };

  return (
    <div style={{ marginBottom: 18 }}>
      {label && (
        <label
          htmlFor={selectId}
          className="text-xs"
          style={{
            display: "flex",
            alignItems: "center",
            gap: 6,
            fontWeight: 700,
            letterSpacing: "0.08em",
            color: darkMode ? "rgba(165,180,252,0.9)" : "rgba(79,70,229,0.85)",
            marginBottom: 7,
            textTransform: "uppercase",
          }}
        >
          {label}
          <FieldBadge required={required} />
        </label>
      )}
      <div style={{ position: "relative" }}>
        <select
          id={selectId}
          value={value}
          onChange={(e) => onChange && onChange(e.target.value)}
          className="text-base"
          style={selectStyle}
          onFocus={(e) => {
            e.target.style.borderColor = darkMode ? "rgba(129,140,248,0.6)" : "rgba(99,102,241,0.5)";
            e.target.style.boxShadow = `0 0 0 3px ${darkMode ? "rgba(129,140,248,0.2)" : "rgba(99,102,241,0.15)"}`;
          }}
          onBlur={(e) => {
            e.target.style.borderColor = darkMode ? "rgba(129,140,248,0.3)" : "rgba(99,102,241,0.25)";
            e.target.style.boxShadow = "none";
          }}
          {...props}
        >
          {placeholder && (
            <option value="" disabled>
              {placeholder}
            </option>
          )}
          {options.map((opt) => (
            <option key={opt.value || opt} value={opt.value || opt}>
              {opt.label || opt}
            </option>
          ))}
        </select>
        <div
          className="text-sm"
          style={{
            position: "absolute",
            right: 14,
            top: "50%",
            transform: "translateY(-50%)",
            pointerEvents: "none",
            opacity: 0.5,
          }}
        >
          ▾
        </div>
      </div>
    </div>
  );
}
